import { of as observableOf,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Contacts, RecentUsers, UserData } from '../data/users';

@Injectable()
export class UserService extends UserData {

  private time: Date = new Date;

  private users = {
    RE: { name: '', picture: 'assets/images/Royal.jpg' },
    vodafone: { name: '', picture: 'assets/images/okinawa.jpg' },
    Msil:{name:'',picture: 'assets/images/msil.jpg'},
    jaguar:{name:'',picture:'assets/images/JaguarLogo.png'},
    MHDR: { name: '', picture: 'assets/images/mahindra_1.PNG' },
    MG: { name: '', picture: 'assets/images/mglogo.png' },
    CLUSTER: { name: '', picture: '' },
  };
  private types = {
    mobile: 'mobile',
    home: 'home',
    work: 'work',
  };
  private contacts: Contacts[] = [
    { user: this.users.RE, type: this.types.mobile },
    { user: this.users.vodafone, type: this.types.home },
  ];
  private recentUsers: RecentUsers[]  = [
    { user: this.users.vodafone, type: this.types.home, time: this.time.setHours(21, 12)},
    { user: this.users.RE, type: this.types.mobile, time: this.time.setHours(5, 29)},

  ];

  getUsers(): Observable<any> {
    return observableOf(this.users);
  }

  getContacts(): Observable<Contacts[]> {
    return observableOf(this.contacts);
  }

  getRecentUsers(): Observable<RecentUsers[]> {
    return observableOf(this.recentUsers);
  }
}
